(function($) {
	$(document).gp_ready(function () {
		const form = document.querySelector('.reservation-form');
		if (!form) return;

		const submitButton = form.querySelector('button[type="submit"]');
		const requiredInputs = form.querySelectorAll('input[required]');
		if (!submitButton || !requiredInputs.length) return;

		const updateButton = () => {
			const allFilled = Array.from(requiredInputs).every(input => {
				return input.value?.trim().length > 0;
			});

			if (allFilled) {
				submitButton.disabled = false;
				submitButton.classList.remove('-disabled');
				submitButton.textContent = 'Rezervovat';
			} else {
				submitButton.disabled = true;
				if (!submitButton.classList.contains('-disabled')) {
					submitButton.classList.add('-disabled');
					submitButton.textContent = 'Vyplňte prosím všechny údaje';
				}
			}
		};

		requiredInputs.forEach(input => {
			['input', 'change', 'blur'].forEach(event => {
				input.addEventListener(event, updateButton);
			});
		});

		updateButton();
	});

	$(document).gp_ready(function () {
		const form_modal = document.querySelector('.product-reservation-store-form');
		if (!form_modal) return;

		// Dropdown effect
		const locationInputs = form_modal.querySelectorAll('input[name="location_id"]');
		const submitButton = form_modal.querySelector('button[type="submit"]');
		if (!submitButton) return;

		const updateDropdowns = () => {
			locationInputs.forEach(input => {
				const customContent = input
					.closest('.reservation-form-stores__label')
					?.querySelector('.reservation-form-stores__custom-content');

				if (!customContent) return;

				if (input.checked) {
					customContent.classList.add('-open');
				} else {
					customContent.classList.remove('-open');
				}
			});
		};

		const updateSubmitButtonState = () => {
			const checkedInput = form_modal.querySelector('input[name="location_id"]:checked');

			if (!checkedInput) {
				submitButton.disabled = true;
				submitButton.classList.add('-disabled');
				submitButton.textContent = 'Vyberte prodejnu';
				return;
			}

			const isInStock = checkedInput.getAttribute('data-in-stock') === '1';

			if (isInStock) {
				submitButton.disabled = false;
				submitButton.classList.remove('-disabled');
				submitButton.textContent = 'Pokračovat';
			} else {
				submitButton.disabled = true;
				submitButton.classList.add('-disabled');
				submitButton.classList.add('-buy');
				submitButton.textContent = 'Nedostupné na vybrané prodejně';
			}
		};

		locationInputs.forEach(input => {
			input.addEventListener('change', () => {
				updateDropdowns();
				updateSubmitButtonState();
			});
		});

		updateDropdowns();
		updateSubmitButtonState();

		form_modal.addEventListener('submit', function (event) {
			event.preventDefault();

			const checkedInput = form_modal.querySelector('input[name="location_id"]:checked');
			const isInStock = checkedInput?.getAttribute('data-in-stock') === '1';

			if (!isInStock) {
				console.error('Selected location is out of stock');
				return;
			}

			const formData = new FormData(form_modal);
			let data = Object.fromEntries(formData);

			gp_ajax({
				url: ghostpress_params.ajax_url + "&action=" + form_modal.getAttribute('action'),
				method: "POST",
				data,
				success: function (response) {
					console.log('Form submitted successfully:', response);

					// Manually replace fragments
					if (response.data && response.data.fragments && response.data.fragments.replace) {
						Object.keys(response.data.fragments.replace).forEach(selector => {
							const element = document.querySelector(selector);
							if (element) {
								element.innerHTML = response.data.fragments.replace[selector];
							} else {
								console.warn('Selector not found:', selector);
							}
						});
					}
				},
				error: function (error) {
					console.error('Error submitting form:', error);
				}
			});
		});

	});

})(jQuery);